import React from 'react';
import { renderRow } from 'components';
import { IApplicant, IApplicantIdentityDoc } from 'components/models';

const ProfileInfoTab = ({ applicant, applicantIdentityDoc, hideIdentity }: IProps) => {
    const { identityDocType, passport, otherIdentity } = applicantIdentityDoc;

    return (
        <section>
            {!hideIdentity ? (
                <>
                    {renderRow('Тип документа', identityDocType === 'passport' ? 'Общегражданский паспорт' : 'Другое')}

                    {passport ? (
                        <>
                            {renderRow('Серия/номер', passport.serialNumber)}
                            {renderRow('Кем выдан', passport.issuedBy)}
                            {renderRow('Дата выдачи', passport.dateOfIssue.format('DD.MM.YYYY'))}
                            {renderRow('Адрес регистрации', passport.registrationAddress)}
                        </>
                    ) : otherIdentity ? (
                        <>
                            {renderRow('Название документа', otherIdentity.title)}
                            {renderRow('Описание', otherIdentity.data)}
                        </>
                    ) : null}
                </>
            ) : null}

            {renderRow('Фамилия', applicant.lastName, !hideIdentity ? 'mt-5' : undefined)}
            {renderRow('Имя', applicant.firstName)}
            {renderRow('Отчество', applicant.middleName || '')}
            {renderRow('Дата рождения', applicant.birthDate.format('DD.MM.YYYY'))}
        </section>
    );
};

export default ProfileInfoTab;

interface IProps {
    applicant: Omit<IApplicant, 'sex'>;
    applicantIdentityDoc: IApplicantIdentityDoc;
    hideIdentity?: boolean;
}
